export const RouteGetMerchflowStorePog_storePogId_DeliveryConflicts =
  "/merchflow/store/pog/:storePogId/delivery-conflicts";

export interface ParamsGetMerchflowStorePog_storePogId_DeliveryConflicts {
  storePogId: string;
}

/**
 * Marking `store_pog_id` delivered would leave its store with two delivered planograms for the
 * same category and go-live date. A planogram without a go-live date goes live the day it is
 * delivered. Of the two, the later delivery is the one the store runs, so if it goes ahead,
 * `store_pog_id` replaces `delivered_store_pog_id`.
 */
export interface DeliveryGoLiveConflict {
  store: string;
  category_code: string;
  /** The go-live date both planograms share (YYYY-MM-DD). */
  go_live_date: string;
  /** The store POG about to be marked delivered. */
  store_pog_id: number;
  /** The merchflow of the store POG about to be marked delivered. */
  merchflow_name: string;
  /** The store POG already delivered for that store, category and date. */
  delivered_store_pog_id: number;
  delivered_merchflow_id: number | null;
  delivered_merchflow_name: string | null;
}

export interface ResponseGetMerchflowStorePog_storePogId_DeliveryConflicts {
  conflicts: DeliveryGoLiveConflict[];
}
